import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from "moment-timezone";

export class PageLastLoaded extends Component {
  constructor(props) {
    super(props);

    this.state = {
      maxDateResult: '- -/- -/- - - -',
      currentMaxDate: moment("0001-01-01T00:00:00")
    };

    this.easternTzMoment = this.easternTzMoment.bind(this);
  }

  easternTzMoment(easternTzMoment) {
    if (easternTzMoment) {
      let _d = moment.tz(easternTzMoment, 'America/New_York');
      return _d;
    }
  }
  
  componentWillReceiveProps(nextProps) {
    
    let result = [];
    
    //current mu data
    if(this.props.currentWorkDayDataMU !== nextProps.currentWorkDayDataMU) {
      let data = nextProps.currentWorkDayDataMU.uiModelData;
      if(data) {
        for (var muKey in data) {
          if (data.hasOwnProperty(muKey)) {
            let _d = data[muKey].DateUpdated;
            let dateItem = this.easternTzMoment(_d).clone();
            if(dateItem) {
              result.push(dateItem);
            }
          }
        }
      }
      else {
        //reset data up to
        this.setState({
          maxDateResult: '- -/- -/- - - -',
          currentMaxDate: moment("0001-01-01T00:00:00")
        })
      }
    }

    //current team data
    if(this.props.currentWorkDayDataTeam !== nextProps.currentWorkDayDataTeam) {
      let data = nextProps.currentWorkDayDataTeam.uiModelData;
      if(data) {
        for (var teamKey in data) {
          if (data.hasOwnProperty(teamKey)) {
            let _d = data[teamKey].DateUpdated;
            let dateItem = this.easternTzMoment(_d).clone();
            if(dateItem) {
              result.push(dateItem);
            }
          }
        }
      }
      else {
        //reset data up to
        this.setState({
          maxDateResult: '- -/- -/- - - -',
          currentMaxDate: moment("0001-01-01T00:00:00")
        })
      }
    }

    //current agent data
    if(this.props.currentWorkDayDataAgent !== nextProps.currentWorkDayDataAgent) {
      let data = nextProps.currentWorkDayDataAgent.uiModelData;
      if(data) {
        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            let _d = data[key].DateUpdated;
            let dateItem = this.easternTzMoment(_d).clone();
            if(dateItem) {
              result.push(dateItem);
            }
          }
        }
      }
      else {
        //reset data up to
        this.setState({
          maxDateResult: '- -/- -/- - - -',
          currentMaxDate: moment("0001-01-01T00:00:00")
        })
      }
    }

    //find the max
    if(result && result.length > 0) {
      
      let maxMomentDate = moment.max(result);
      let currentMaxDate = this.state.currentMaxDate;
      let minDate = moment("0001-01-01T00:00:00");
      let localDate = '';

      if(maxMomentDate && maxMomentDate.isAfter(currentMaxDate)) {
        currentMaxDate = maxMomentDate;
      }
      
      if(currentMaxDate.isSame(minDate)) {
        localDate = '- -/- -/- - - -';
      }
      else {
        let zone_name =  moment.tz.guess();
        let timezone = moment.tz(zone_name).zoneAbbr() 
        localDate = moment(currentMaxDate).local().format('MM/DD/YYYY hh:mm:ss a') + " " + timezone //render date as user's local
      }

      
      let maxDateResult = localDate;

      this.setState({
          maxDateResult: maxDateResult,
          currentMaxDate: currentMaxDate
      })
    }
  }

  render() {
      let currentTime = new Date();
      let { isTablet, isPerformanceMetricsPage, isDesktop } = this.props;
      let isTabletValid = isTablet && isPerformanceMetricsPage;
      return (
        <div >
          {(isDesktop && isPerformanceMetricsPage) || (isTabletValid)  ? 
              <div className ="page_last_loaded">
                Data Up To: {this.state.maxDateResult}
              </div> 
            : 
            <div className="page_last_loaded">
              Page Last Loaded:{" "}
                {currentTime
                  .toLocaleString()
                  .replace(/,/, " ")
                  .replace(/:\d{2}\s/, " ") +
                  " " +
                  currentTime
                      .toLocaleTimeString("en-us", { timeZoneName: "short" })
                      .split(" ")[2]}
            </div>
          }
        </div>
        
      );
    }
}

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
        currentWorkDayDataMU: state.scorecard.currentWorkDayDataMU,
        currentWorkDayDataTeam: state.scorecard.currentWorkDayDataTeam,
        currentWorkDayDataAgent: state.scorecard.currentWorkDayDataAgent
	};
}

export default connect(
  mapStateToProps,
)(PageLastLoaded);


// WEBPACK FOOTER //
// ./src/features/common/PageLastLoaded.js